import React from 'react';

import best_match from '../../../images/best_match.svg';

import { FOHImage } from '../../ingredients';

export const FOHBestMatchIcon = (props: any) => (
  <FOHImage
    source={{ uri: best_match }}
    style={{ width: 16, height: 13, ...props.style }}
  />
);
